import { render, staticRenderFns } from "./BbppModeloBancaPrivada.vue?vue&type=template&id=85190e98"
import script from "./BbppModeloBancaPrivada.vue?vue&type=script&lang=js"
export * from "./BbppModeloBancaPrivada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports